import { Spin } from 'antd';

export default function RouteLoader() {
  return (
    <div className="h-[75dvh] grid items-center">
      <Spin size="large" />
    </div>
  );
}
